import * as React from 'react';
import { Icon } from '../modules';

interface IIconTextProps {
    type?: string;
    img?: string;
    icon?: string;
    children?: any;
}

const IconText = (props: IIconTextProps) => {
    const name: string = 'iconText';
    const {img, children, type, icon} = props;
    return (
        <div className={name + (type ? ' ' + name + '--' + type : '')}>
            {img && 
                <img src={img} alt={name} className="iconText__icon" />
            }
            {icon &&
                <div className="iconText__icon">
                    <Icon type={icon}/>
                </div>
            }
            <div className="iconText__content">{children}</div>
        </div>
    );
};

export default IconText;



// WEBPACK FOOTER //
// ./src/modules/IconText/IconText.tsx